import { render, staticRenderFns } from "./CategoryUpdate.vue?vue&type=template&id=d726b0d4&"
import script from "./CategoryUpdate.vue?vue&type=script&lang=js&"
export * from "./CategoryUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports